// extracted by mini-css-extract-plugin
export default {"navbar_drawer":"style_navbar_drawer__8UeUw","drawer_title":"style_drawer_title__Orl50"};